<script>
/**
 * ****************************************************************************
 * @description     :   List Component
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – phuongdt@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import template
 */
import template from './template.html';

/**
 * Define content of list component
 */
var AnsPanelHeader = {
    template: template,
    props: {
        label: String,
        subLabel: String,
        panelClass: String,
        modelValue: [String, Number],
        onChange: Function
    },
    emits: ['update:modelValue'],
    data() {
        return {
            vewValue: ''
        };
    },
    mounted() {
        this.vewValue = this.modelValue ? this.modelValue : this.value;
    },
    methods: {
        /**
         * select item in table
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params : value
         * @access : private
         */
        selectedOption(val) {
            return this.vewValue == val;
        },
        /**
         * updated item in table
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params : value
         * @access : private
         */
        updateInput(val) {
            this.vewValue = val;
            this.$emit('update:modelValue', this.vewValue);
            if (this.onChange) {
                this.onChange(this.vewValue);
            }
        }
    }
};
export default AnsPanelHeader;
</script>
